import { settings } from '@/settings'

export const passwordStrength = function (value) {
  return settings.passwordValidRE.test(value)
}
